export default {"src":"/_next/static/media/shiraz.2dc53190.svg","height":37,"width":142,"blurWidth":0,"blurHeight":0};